import { planningSettings, currentReview } from '../engine/planning.js';
import { billOfMaterials } from '../engine/coverage.js';
import { framingPenalty } from '../engine/plannerCandidates.js';
import { installationEstimate } from '../engine/installation.js';
import { fmt } from '../engine/constants.js';

/** The plan's review status at a glance, shown at the top of the Review step once cameras exist. */
export default function ReviewSummary({ store, onStage }) {
  const S = store.doc, R = store.cov, goal = planningSettings(S).target, review = currentReview(S);
  if (!S.cams.length) return null;
  const { unknown } = billOfMaterials(S);
  const framing = S.cams.filter(c => framingPenalty(S, c) >= 0.5).length, installation = installationEstimate(S);
  const tasks = [...(R?.entries || []), ...(R?.tasks || [])];
  return <div className="review-summary" aria-label="Plan review summary">
    <span>Area <b>{R ? `${fmt(R.stats.metPct, 1)}% / ${goal}%` : 'Updating…'}</b></span>
    <button onClick={() => onStage('tasks')}>Capture needs <b>{tasks.length ? `${tasks.filter(t => t.complete).length}/${tasks.length}` : 'None set'}</b></button>
    <span>Verification <b>{review ? review.verification.passed ? 'Geometry passed' : review.verification.nearMiss ? 'Within allowance' : 'Shortfall' : S.review ? 'Needs recheck' : 'Not checked'}</b></span>
    <span>Framing <b>{framing ? `${framing} to review` : 'Visual check needed'}</b></span>
    <button onClick={() => onStage('quotes')}>Camera prices <b>{unknown ? `${unknown} missing` : 'Entered'}</b></button>
    <button onClick={() => onStage('install')}>Installation <b>{installation.complete ? 'Prices entered' : `${installation.unquoted.length} unquoted`}</b></button>
  </div>;
}
